import {
  GET_USERS_LIST_BY_TYPE, UPDATE_STATUS, VERIFY_USERS, REGISTER_USERS_BY_TYPE, UPDATE_STATUS_COGNITO, USER_ERROR, USER_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  users: [],
  msg: {
    type: "",
    text: ""
  },
  response: null
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_LIST_BY_TYPE:
      state = {
        ...state,
        loading: true,
        msg: {
          type: "",
          text: ""
        },
      }
      break;
    case REGISTER_USERS_BY_TYPE:
      state = {
        ...state,
        loading: false,
        users: action.payload
      }
      break;
    case UPDATE_STATUS:
      state = {
        ...state,
        loading: true,
      }
      break;
    case UPDATE_STATUS_COGNITO:
      state = {
        ...state,
        loading: true,
      }
      break;
    case USER_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      }
      break;
    case USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        msg: action.payload
      }
      break;
    case UPDATE_USER:
      state = {
        ...state,
        loading: true,
        response: null
      }
      break;
    case UPDATE_USER_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        response: action.payload,
      }
      break;
    case UPDATE_USER_FAIL:
      state = {
        ...state,
        error: action.payload,
        loading: false,
        response: null,
      }
      break;
    default:
      state = { ...state }
      break
  }
  return state;
}

export default users;